import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home/Home'
import Pickup from '../pages/Pickup/Pickup'
import GetClient from '../pages/Pickup/GetClient/GetClient'
import GetState from '../pages/Pickup/GetState/GetState'
import GetCode from '../pages/Pickup/GetCode/GetCode'
import GetStateExclusion from '../pages/Pickup/GetExclusion/GetStateExclusion'
import Review from '../pages/Review/Review'
import Admin from '../pages/Admin/Admin'
import Thankyou from '../pages/Thankyou/Thankyou'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
		{
			path: '/pickup',
			component: Pickup,
			children: [
				{
					path: 'client-login',
					name: 'client-login',
					component: GetClient
				},
				{
					path: 'get-state',
					name: 'get-state',
					component: GetState
				},
				{
					path: 'get-state-exclusion',
					name: 'get-state-exclusion',
					component: GetStateExclusion
				},
				{
					path: 'get-code/:state',
					name: 'get-code',
					component: GetCode,
					props: true
				}
			]
		},
		{
			path: '/review',
			name: 'review',
			component: Review
		},
		{
			path: '/admin',
			name: 'admin',
			component: Admin
		},
		{
			path: '/thankyou',
			name: 'thankyou',
			component: Thankyou
		}

  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js